// src/internal/is-development.false.ts
var IS_DEVELOPMENT = false;
export {
  IS_DEVELOPMENT
};
//# sourceMappingURL=is-development.false.mjs.map
